import React, { FC, useMemo, useRef } from 'react';

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from 'devextreme-react/data-grid';

import moment from 'moment';

import { AppCard } from 'components/appComponents';
import { Button, Template } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { onExporting } from './utils';

type Props = {
  dateBegin: string;
  dateEnd: string;
  transportId: number | null;
};

const MainList: FC<Props> = ({ dateBegin, dateEnd, transportId }) => {
  const refGrid = useRef<DataGrid | null>(null);

  const salaryDataStore: any = useMemo(() => {
    if (transportId)
      return $createStore(
        `/v1/ComingNomenclature/fareDetails/${transportId}?dateBegin=${dateBegin}&dateEnd=${dateEnd}`,
        'date',
      );
    return [];
  }, [dateBegin, dateEnd, transportId]);

  const dateBeginText = moment(dateBegin).format('DD.MM.YYYY');
  const dateEndText = moment(dateEnd).format('DD.MM.YYYY');

  const onExportingHandler = (e: any) => {
    onExporting(e, `${dateBeginText} - ${dateEndText}`);
  };

  const refresh = () => refGrid.current?.instance.refresh();

  return (
    <div className="container-dev">
      <AppCard>
        <DataGrid
          dataSource={salaryDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          key="id"
          ref={refGrid}
          onExporting={onExportingHandler}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onToolbarPreparing={(e) => {
            e.toolbarOptions?.items?.unshift({
              location: 'after',
              template: 'refresh',
            });
          }}
        >
          <StateStoring enabled={true} type="localStorage" storageKey="comingNomenclatureDareDetail" />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Template name="refresh">
            <Button icon="refresh" onClick={refresh} />
          </Template>
          <Column dataField="date" caption="Дата" dataType="date" width={120} />
          <Column dataField="object" caption="Карьер" />
          <Column dataField="nomenclature" caption="Груз" width={160} />
          <Column dataField="count" caption="Выгружено" width={120} />
          <Column dataField="unitName" caption="Ед. изм." width={120} />
          <Column dataField="factory" caption="Место выгрузки" />

          <Export enabled={true} />
          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default MainList;
